import { PencilLine } from 'lucide-react';

import { cn } from '@/lib/utils';

interface BadgeEdicaoNovaProps {
  tamanho?: 'sm' | 'md';
  className?: string;
}

/**
 * Sinal de que os dados do pedido foram corrigidos e a Regulação ainda não viu.
 *
 * Mesma forma dos selos de documento novo e cancelamento pedido, pela mesma
 * razão: na fila, o olho procura a etiqueta arredondada. Aqui o que está em
 * jogo é analisar o pedido certo — uma especialidade trocada depois da leitura
 * muda a decisão, e sem o selo o regulador seguiria com o que leu antes.
 */
export function BadgeEdicaoNova({ tamanho = 'md', className }: BadgeEdicaoNovaProps) {
  const descricao = 'Os dados do pedido foram corrigidos e a Regulação ainda não abriu.';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        'border-status-lido-borda bg-status-lido-fundo text-status-lido-texto',
        tamanho === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className,
      )}
      title={descricao}
    >
      <PencilLine
        className={tamanho === 'sm' ? 'size-3' : 'size-3.5'}
        aria-hidden="true"
        strokeWidth={2.25}
      />
      <span>Dados corrigidos</span>
      <span className="apenas-leitor-tela">. {descricao}</span>
    </span>
  );
}
